import { Pipe, PipeTransform } from '@angular/core';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';

@Pipe({
	name: 'labelQuickSearch',
})
export class LabelQuickSearchPipe implements PipeTransform {
	transform(labels: ILabel[], searchTerm: string): ILabel[] {
		if (!searchTerm) {
			return labels;
		}

		return labels.filter(label => this.isMatch(label, searchTerm.toLowerCase()));
	}

	private isMatch(label: ILabel, searchTerm: string): boolean {
		if (label.name.toLowerCase().includes(searchTerm)) {
			return true;
		}

		if (label.children && label.children.length > 0) {
			return label.children.some(child => this.isMatch(child, searchTerm));
		}

		return false;
	}
}
